<quill-editor format="html" [ngModel]="content"  (onFocus)="initialized = true" (onContentChanged)="onEditorChange($event)" (onEditorCreated)="initEditor($event)">
</quill-editor>
